import React from 'react';

export const CustomButton = ({ variant = 'primarySmall', icon: Icon, children, className, onClick, disabled, type }) => {
  const baseStyles = 'flex items-center justify-center transition-colors';
  const variants = {
    primarySmall: 'default-button-primary-small',
    primaryMedium: 'default-button-primary-medium',
    primaryLarge: 'default-button-primary-large',
    primaryXLarge: 'default-button-primary-xl',
    secondarySmall: 'default-button-secondary-small',
    secondaryMedium: 'default-button-secondary-medium',
    secondaryLarge: 'default-button-secondary-large',
    secondaryXLarge: 'default-button-secondary-xl',
    primaryWhiteSmall: 'primary-white-small',
    primaryWhiteMedium: 'primary-white-medium',
    primaryWhiteLarge: 'primary-white-large',
    primaryWhiteXLarge: 'primary-white-xl',
    secondaryWhiteSmall: 'secondary-white-small',
    secondaryWhiteMedium: 'secondary-white-medium',
    secondaryWhiteLarge: 'secondary-white-large',
    secondaryWhiteXLarge: 'secondary-white-xl',
    primaryMagentaSmall: 'primary-magenta-small',
    primaryMagentaMedium: 'primary-magenta-medium',
    primaryMagentaLarge: 'primary-magenta-large',
    primaryMagentaXLarge: 'primary-magenta-xl',
    secondaryMagentaSmall: 'secondary-magenta-small',
    secondaryMagentaMedium: 'secondary-magenta-medium',
    secondaryMagentaLarge: 'secondary-magenta-large',
    secondaryMagentaXLarge: 'secondary-magenta-xl',
    b2cWhiteSmall: 'b2c-white-small',
    b2cWhiteMedium: 'b2c-white-medium',
    b2cWhiteLarge: 'b2c-white-large',
    b2cWhiteXLarge: 'b2c-white-xl',
    b2cPrimaryRound: 'b2c-primary-round',
    b2cSecondaryRound: 'b2c-secondary-round',
    b2cGreyRound: 'b2c-grey-round',
  };

  return (
    <button className={`${className} ${baseStyles} ${variants[variant]}`} onClick={onClick} disabled={disabled} type={type ? type : 'button'}>
      {Icon && <Icon className="w-5 h-5"/>}
      {children}
    </button>
  );
};
